import { render } from "./RolePermissionTab.vue?vue&type=template&id=17a0616c&scoped=true"
import script from "./RolePermissionTab.vue?vue&type=script&lang=js"
export * from "./RolePermissionTab.vue?vue&type=script&lang=js"

import "./RolePermissionTab.vue?vue&type=style&index=0&id=17a0616c&lang=scss&scoped=true"
import "./RolePermissionTab.vue?vue&type=style&index=1&id=17a0616c&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a0616c"]])

export default __exports__